import { useContext } from "react";
import { AdvertiserTimezoneContext } from "../contexts/AdvertiserTimezoneContext";

export const useAdvertiserTimezone = () => {
  const value = useContext(AdvertiserTimezoneContext);
  if (!value) {
    throw new Error(
      "useAdvertiserTimezone must be used within AdvertiserTimezoneProvider"
    );
  }
  return value;
};

export default useAdvertiserTimezone;
